import { render, staticRenderFns } from "./arena2036-DataGridWidget.vue?vue&type=template&id=6c98b682&scoped=true"
import script from "./arena2036-DataGridWidget.vue?vue&type=script&lang=js"
export * from "./arena2036-DataGridWidget.vue?vue&type=script&lang=js"
import style0 from "./arena2036-DataGridWidget.vue?vue&type=style&index=0&id=6c98b682&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c98b682",
  null
  
)

export default component.exports